<script setup lang="ts">
import { FolderHeart } from 'lucide-vue-next';
import CardPreview from '@/components/CardPreview.vue';
import { Button } from '@/components/ui/button';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/components/ui/popover';
import useApp from '@/composables/useApp.ts';

const app = useApp();
</script>

<template>
    <Popover>
        <PopoverTrigger as-child>
            <Button
                variant="ghost"
                size="icon-lg"
            >
                <FolderHeart />
                <span class="sr-only">Favoriten</span>
            </Button>
        </PopoverTrigger>
        <PopoverContent
            class="flex max-h-120 w-80 flex-col gap-2 overflow-y-auto overscroll-contain"
            @open-auto-focus.prevent="() => {}"
        >
            <p class="p-small -mt-0.5 font-semibold">
                <a :href="app.site.url + 'merkliste'">Ihre Merkliste</a>
            </p>
            <p
                v-if="app.favorites.length === 0"
                class="p-small text-muted-foreground"
            >
                Noch keine Favoriten. Fügen Sie Inhalte Ihrer Merkliste hinzu
                für schnellen Zugriff.
            </p>
            <CardPreview
                v-for="favorite in app.favorites"
                :key="favorite.uid"
                variant="sm"
                :type="favorite.type"
                :uid="favorite.uid"
                :title="favorite.title"
                :url="favorite.url"
                :direct-link="favorite.directLink"
                :direct-link-target="favorite.directLinkTarget"
                :preview="favorite.preview"
                :badge="favorite.badge"
                :is-new="favorite.isNew"
            />
        </PopoverContent>
    </Popover>
</template>
